
export default class Vector2 {
	constructor (x, y) {
		this.x = x;
		this.y = y;
	}

	distance (vec2) {
		var dx = vec2.x - this.x;
		var dy = vec2.y - this.y;
		return Math.sqrt(dx * dx + dy * dy);
	}

	// distanceSquared (vec2) {
	// 	var dx = vec2.x - this.x;
	// 	var dy = vec2.y - this.y;
	// 	return dx * dx + dy * dy;
	// }

	setVector2 (vec2) {
		this.x = vec2.x;
		this.y = vec2.y;
		return this;
	}

	// addScalar (s) {
	// 	this.x += s;
	// 	this.y += s;
	// 	return this;
	// }

	// subtractScalar (s) {
	// 	this.x -= s;
	// 	this.y -= s;
	// 	return this;
	// }

	multiplyScalar (s) {
		this.x *= s;
		this.y *= s;
		return this;
	}

	// divideScalar (s) {
	// 	this.x /= s;
	// 	this.y /= s;
	// 	return this;
	// }

	add (vec2) {
		this.x += vec2.x;
		this.y += vec2.y;
		return this;
	}

	subtract (vec2) {
		this.x -= vec2.x;
		this.y -= vec2.y;
		return this;
	}

	multiply (vec2) {
		this.x *= vec2.x;
		this.y *= vec2.y;
		return this;
	}

	divide (vec2) {
		this.x /= vec2.x;
		this.y /= vec2.y;
		return this;
	}

	normalize () {
		var length = Math.sqrt(this.x * this.x + this.y * this.y);
		if (length === 0) { length = 1; }

		var l = 1 / length;
		this.x *= l;
		this.y *= l;
		return this;
	}

	// negate () {
	// 	this.x = -this.x;
	// 	this.y = -this.y;
	// 	return this;
	// }

	rotate (rotation) {
		if (rotation === 0) {
			return this;
		}

		var cos = Math.cos(rotation);
		var sin = Math.sin(rotation);

		var x = this.x;
		var y = this.y;

		this.x = x * cos + y * sin;
		this.y = y * cos - x * sin;
		return this;
	}

	// skew (skew) {
	// 	var skewX = skew.x;
	// 	var skewY = skew.y;
	// 	if (skewX === 0 && skewY === 0) {
	// 		return this;
	// 	}

	// 	var x = this.x;
	// 	var y = this.y;

	// 	this.x = x + y * Math.tan(skewX);
	// 	this.y = y + x * Math.tan(skewY);
	// 	return this;
	// }

	// multiplyMatrix3x3 (mat3) {
	// 	var m = mat3._matrix;
	// 	var x = this.x;
	// 	var y = this.y;

	// 	this.x = x * m[0] + y * m[3];
	// 	this.y = x * m[1] + y * m[4];
	// 	return this;
	// }

	normal () {
		var length = Math.sqrt(this.x * this.x + this.y * this.y);
		if (length === 0) { length = 1; }
		return new Vector2(this.x / length, this.y / length);
	}

	copy () {
		return new Vector2(this.x, this.y);
	}

	length () {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	}

	dot (vec2) {
		return this.x * vec2.x + this.y * vec2.y;
	}

	// toString () {
	// 	return '[' + this.x + ', ' + this.y + ']';
	// }
}


// Vector2.lerp = function (t, vec2a, vec2b) {
// 	return new Vector2(
// 		vec2a.x * (1 - t) + vec2b.x * t,
// 		vec2a.y * (1 - t) + vec2b.y * t
// 	);
// };

Vector2.prototype.translate = Vector2.prototype.add;
Vector2.prototype.scale = Vector2.prototype.multiply;
Vector2.prototype.untranslate = Vector2.prototype.subtract;
Vector2.prototype.unscale = Vector2.prototype.divide;
